import React from "react";

const StarAltIcon = ({ 
  fill = "#888888", 
  score = null, 
  maxStars = 5, 
  className = "",
  ...delegated 
}) => {
  // If score is provided, render multiple stars
  if (score !== null) {
    const normalizedScore = Math.max(0, Math.min(maxStars, parseFloat(score)));
    
    return (
      <div className={`star-rating ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        {Array.from({ length: maxStars }, (_, index) => {
          const starNumber = index + 1;
          const isFilled = starNumber <= normalizedScore;
          const isPartial = starNumber > normalizedScore && starNumber - 1 < normalizedScore;
          
          return (
            <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
              {/* Background star (empty) */}
              <svg
                height="15"
                viewBox="0 1 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ 
                  display: 'block', // Removes baseline spacing issues
                }}
                {...delegated}
              >
                <path
                  d="M11.9883 5.14288H11.9766C11.9844 5.15851 11.9883 5.17413 11.9883 5.18976C11.9961 5.20538 12 5.22101 12 5.23663C12 5.28351 11.9883 5.32648 11.9648 5.36554C11.9492 5.4046 11.9258 5.43976 11.8945 5.47101L8.71875 7.97882L10.1367 11.9866C10.1445 12.0023 10.1484 12.0179 10.1484 12.0335C10.1562 12.0491 10.1602 12.0648 10.1602 12.0804C10.1602 12.1585 10.1289 12.2249 10.0664 12.2796C10.0117 12.3421 9.94531 12.3734 9.86719 12.3734C9.84375 12.3734 9.81641 12.3694 9.78516 12.3616C9.76172 12.3538 9.73828 12.3421 9.71484 12.3265L6 10.0999L2.28516 12.3265C2.26172 12.3421 2.23438 12.3538 2.20312 12.3616C2.17969 12.3694 2.15625 12.3734 2.13281 12.3734C2.05469 12.3734 1.98438 12.3421 1.92188 12.2796C1.86719 12.2249 1.83984 12.1585 1.83984 12.0804C1.83984 12.0648 1.83984 12.0491 1.83984 12.0335C1.84766 12.0179 1.85547 12.0023 1.86328 11.9866L3.28125 7.97882L0.105469 5.47101C0.0742188 5.43976 0.046875 5.4046 0.0234375 5.36554C0.0078125 5.32648 0 5.28351 0 5.23663C0 5.15851 0.0273438 5.0921 0.0820312 5.03741C0.136719 4.98273 0.207031 4.95538 0.292969 4.95538H4.34766L5.73047 1.04132C5.74609 0.978821 5.77734 0.931946 5.82422 0.900696C5.87891 0.861633 5.9375 0.842102 6 0.842102C6.0625 0.842102 6.11719 0.861633 6.16406 0.900696C6.21875 0.931946 6.25391 0.978821 6.26953 1.04132L7.65234 4.94366H11.707C11.7773 4.94366 11.8359 4.9632 11.8828 5.00226C11.9297 5.04132 11.9648 5.0882 11.9883 5.14288Z"
                  fill="#e0e0e0"
                />
              </svg>
              
              {/* Filled star overlay */}
              {(isFilled || isPartial) && (
                <svg
                  height="15"
                  viewBox="0 1 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    clipPath: isPartial 
                      ? `inset(0 ${100 - (normalizedScore % 1) * 100}% 0 0)` 
                      : 'none'
                  }}
                  {...delegated}
                >
                  <path
                    d="M11.9883 5.14288H11.9766C11.9844 5.15851 11.9883 5.17413 11.9883 5.18976C11.9961 5.20538 12 5.22101 12 5.23663C12 5.28351 11.9883 5.32648 11.9648 5.36554C11.9492 5.4046 11.9258 5.43976 11.8945 5.47101L8.71875 7.97882L10.1367 11.9866C10.1445 12.0023 10.1484 12.0179 10.1484 12.0335C10.1562 12.0491 10.1602 12.0648 10.1602 12.0804C10.1602 12.1585 10.1289 12.2249 10.0664 12.2796C10.0117 12.3421 9.94531 12.3734 9.86719 12.3734C9.84375 12.3734 9.81641 12.3694 9.78516 12.3616C9.76172 12.3538 9.73828 12.3421 9.71484 12.3265L6 10.0999L2.28516 12.3265C2.26172 12.3421 2.23438 12.3538 2.20312 12.3616C2.17969 12.3694 2.15625 12.3734 2.13281 12.3734C2.05469 12.3734 1.98438 12.3421 1.92188 12.2796C1.86719 12.2249 1.83984 12.1585 1.83984 12.0804C1.83984 12.0648 1.83984 12.0491 1.83984 12.0335C1.84766 12.0179 1.85547 12.0023 1.86328 11.9866L3.28125 7.97882L0.105469 5.47101C0.0742188 5.43976 0.046875 5.4046 0.0234375 5.36554C0.0078125 5.32648 0 5.28351 0 5.23663C0 5.15851 0.0273438 5.0921 0.0820312 5.03741C0.136719 4.98273 0.207031 4.95538 0.292969 4.95538H4.34766L5.73047 1.04132C5.74609 0.978821 5.77734 0.931946 5.82422 0.900696C5.87891 0.861633 5.9375 0.842102 6 0.842102C6.0625 0.842102 6.11719 0.861633 6.16406 0.900696C6.21875 0.931946 6.25391 0.978821 6.26953 1.04132L7.65234 4.94366H11.707C11.7773 4.94366 11.8359 4.9632 11.8828 5.00226C11.9297 5.04132 11.9648 5.0882 11.9883 5.14288Z"
                    fill="#ff7d4a"
                  />
                </svg>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  // If no score provided, render single star (original behavior)
  return (
    <svg
      height="15"
      viewBox="0 1 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...delegated}
    >
      <path
        d="M11.9883 5.14288H11.9766C11.9844 5.15851 11.9883 5.17413 11.9883 5.18976C11.9961 5.20538 12 5.22101 12 5.23663C12 5.28351 11.9883 5.32648 11.9648 5.36554C11.9492 5.4046 11.9258 5.43976 11.8945 5.47101L8.71875 7.97882L10.1367 11.9866C10.1445 12.0023 10.1484 12.0179 10.1484 12.0335C10.1562 12.0491 10.1602 12.0648 10.1602 12.0804C10.1602 12.1585 10.1289 12.2249 10.0664 12.2796C10.0117 12.3421 9.94531 12.3734 9.86719 12.3734C9.84375 12.3734 9.81641 12.3694 9.78516 12.3616C9.76172 12.3538 9.73828 12.3421 9.71484 12.3265L6 10.0999L2.28516 12.3265C2.26172 12.3421 2.23438 12.3538 2.20312 12.3616C2.17969 12.3694 2.15625 12.3734 2.13281 12.3734C2.05469 12.3734 1.98438 12.3421 1.92188 12.2796C1.86719 12.2249 1.83984 12.1585 1.83984 12.0804C1.83984 12.0648 1.83984 12.0491 1.83984 12.0335C1.84766 12.0179 1.85547 12.0023 1.86328 11.9866L3.28125 7.97882L0.105469 5.47101C0.0742188 5.43976 0.046875 5.4046 0.0234375 5.36554C0.0078125 5.32648 0 5.28351 0 5.23663C0 5.15851 0.0273438 5.0921 0.0820312 5.03741C0.136719 4.98273 0.207031 4.95538 0.292969 4.95538H4.34766L5.73047 1.04132C5.74609 0.978821 5.77734 0.931946 5.82422 0.900696C5.87891 0.861633 5.9375 0.842102 6 0.842102C6.0625 0.842102 6.11719 0.861633 6.16406 0.900696C6.21875 0.931946 6.25391 0.978821 6.26953 1.04132L7.65234 4.94366H11.707C11.7773 4.94366 11.8359 4.9632 11.8828 5.00226C11.9297 5.04132 11.9648 5.0882 11.9883 5.14288Z"
        fill={fill}
      />
    </svg>
  );
};

export { StarAltIcon };